// extracted by mini-css-extract-plugin
module.exports = {"htmlContent":"TextOnlyContent_htmlContent__12B8x"};